import useAuthStore from '@/stores/useAuthStore'
import { paths } from '@/utils/path'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { Card, CardBody } from '@vnetwork/datacentral-ui/primitives'

const AuthLayout = () => {
    const { employee } = useAuthStore()
    const [searchParams] = useSearchParams()

    if (employee) {
        return <Navigate to={searchParams?.get('redirect') || paths.home} />
    }

    return (
        <div className="min-h-svh relative bg-surface overflow-hidden">
            {/* Background Image - Full Screen */}
            <div className="absolute inset-0">
                <img
                    className="w-full h-full object-cover rotate-180"
                    src="/images/auth-background.webp"
                    alt="Login background"
                />
                {/* Optional overlay for better contrast on mobile and tablet */}
                <div className="absolute inset-0 bg-[var(--vn-overlay-bg)] opacity-20 lg:hidden"></div>
            </div>

            {/* Login Form Container - Responsive */}
            <div className="relative z-10 min-h-svh flex items-center justify-center">
                <div className="w-full lg:ml-12 xl:ml-16 2xl:ml-20 max-w-sm sm:max-w-md md:max-w-lg lg:max-w-md xl:max-w-lg">
                    <Card className="bg-surface/95 backdrop-blur-sm">
                        <CardBody className="p-6 sm:p-8">
                            <Outlet />
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout
